const UNCONFIRMED = 'UNCONFIRMED'

export default ($vueInstance, { message: code }) =>
  code === UNCONFIRMED
    ? $vueInstance.$router.push({ name: 'login.invite' })
    : true
